export default String.raw`
.companies {
    padding: 0 32px;

    &__prev, &__next {
        visibility: hidden;
    }

    &__swiper {
        overflow-x: visible;

        .swiper-button-pause {
            top: -52px;
            box-shadow: unset;
        }
    }

    &__slide {
        width: calc(100% / 5.5);
    }
}
`